export class CostCenterSummary {
    costCenterId: number;
    address: string;
    name: string;
    lastAccountingTime: Date;
    saldoEnd: number;
    cashInAmount: number;
    cashOutAmount: number;
    cashSaldoAmount: number;
    payInAmount: number;
    payOutAmount: number;
    depositAmount: number;
    payOutForOthersAmount: number;
    payOutByOthersAmount: number;
    creditTicketsAmount: number;
    notPaidAmount: number;
    contractDuty: number;
    bruto: number;
    saldoStart: number;
    daysSinceLastPositiveCharge: number;
    partnerAccountingLoan: number;
    reservationForOnlineWithdrawalAmount: number;
    minimumCashHold: number;
    partnerContractTypeId: number;
    creditPaidOutByOthersAmount: number;
    creditDepositToWalletAmount: number;
    dispenserHasData: boolean;
    coinBoxAmount: number;
    moneyBoxAmount: number;
    dispenserBoxAmount: number;
    dispenserBoxBills: BillInfo[];

    constructor() { }

    get ContractType(): string {
      return 'ContractId' + this.partnerContractTypeId;
  }
}

export class BillInfo{
    denomination: number;
    count: number;
    amount: number;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/admin-state/state.model.ts